import { AxiosError } from 'axios';

export const wrapError = (err: AxiosError | any) => {
  if (err.isAxiosError) {
    const e = err as AxiosError;
    return {
      error: (e.response?.data as any)?.error
    };
  }

  return {
    error: err
  };
};
